import { Injector, NgModule } from '@angular/core';
import { DonnaCoreBootstrapModule } from './core-bootstrap.module';
import {
    ChassisCoreModule,
    RouteService,
    RoutingModule,
    RoutingModuleContract
} from '@kaiser-software/chassis-core';

// const LazyRoutes = [
//     {path: 'lazy', loadChildren: 'app/pages/users/users.module#UsersModule'}
// ];

@NgModule({
    imports: [
        ChassisCoreModule,
        DonnaCoreBootstrapModule,
    ],
    exports: [],
    entryComponents: [],
    declarations: [],
    providers: [],
})
export class DonnaCoreRoutingModule extends RoutingModule implements RoutingModuleContract {
    public boot(injector: Injector) {
    }

    public routes(routeService: RouteService) {
    }
}



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/core-routing.module.ts